import { yupResolver } from '@hookform/resolvers/yup';
import { useForm } from 'react-hook-form';
import { LoginENTFormSchema, LoginENTMutation } from './LoginENTForm.types';
import { getLoginENTForm } from './LoginENTForm.schema';
import { useMutation, useQueryClient } from 'react-query';
import { loginCommercialFormData } from './LoginENTForm.data';
import { Link, useNavigate } from 'react-router-dom';
import Form from '../../../../commons/Form/Form';
import { LOGIN_ENT_QUERY_KEY, loginENTQuery } from './LoginENTForm.query';
import { setProfile } from '../../../../../store/authentication/authenticationActions/authenticationActions';
import { UserRoles } from '../../../../../types/models/user/user.types';
import { useDispatch } from 'react-redux';
import { api } from '../../../../../utils/api/api';
import { useCookies } from 'react-cookie';
import moment from 'moment';

export default () => {
  const navigate = useNavigate();

  const dispatch = useDispatch();
  const queryClient = useQueryClient();

  const [, setCookie] = useCookies(['token']);

  const formProps = useForm<LoginENTFormSchema>({
    resolver: yupResolver(getLoginENTForm),
    mode: 'onChange',
    reValidateMode: 'onChange',
  });

  const { handleSubmit } = formProps;

  const { mutate } = useMutation<Awaited<ReturnType<LoginENTMutation>>, Error, LoginENTFormSchema>(
    (data) => loginENTQuery(data),
    {
      mutationKey: LOGIN_ENT_QUERY_KEY,
      onMutate: () => queryClient.cancelMutations(),
      onSuccess: ({ user, accessToken }) => {
        setProfile({ ...user, role: UserRoles.Entreprise })(dispatch);
        api.setHeader('authorization', `Bearer ${accessToken}`);
        setCookie('token', accessToken, {
          expires: moment().add(60, 'minutes').toDate(),
          path: '/',
        });
        if (user.id_step === 3) {
          navigate('/dashboard');
        }
      },
      onError: (error) => alert(error.message),
    }
  );

  const onSubmit = handleSubmit((data) => mutate(data));

  return (
    <>
      <Form<LoginENTFormSchema>
        data={loginCommercialFormData}
        style={{
          width: 400,
          alignSelf: 'center',
        }}
        {...{ formProps, onSubmit }}
        afterInputsElement={
          <Link to="/password/forgot/ENT">
            <span className="form__after-inputs-link text-secondary">Mot de passe oublié ?</span>
          </Link>
        }
        isCompany
      />
    </>
  );
};
